export const allsavfeUrl = "https://allsavfe.com";